import { CONSENT_ACTION, CONSENT_STATE } from '../constants'

export const consentReducer = (state = CONSENT_STATE, action) => {
  switch (action.type) {
    case CONSENT_ACTION.GRANT_ALL:
      return {
        ...state,
        hasShownBanner: true,
        analytics: true,
        marketing: true,
        preferences: true
      }

    case CONSENT_ACTION.DENY_ALL:
      return {
        ...state,
        hasShownBanner: true,
        analytics: false,
        marketing: false,
        preferences: false
      }

    case CONSENT_ACTION.UPDATE_PREFERENCES:
      return {
        ...state,
        hasShownBanner: true,
        analytics: action.payload.analytics ?? state.analytics,
        marketing: action.payload.marketing ?? state.marketing,
        preferences: action.payload.preferences ?? state.preferences
      }

    case CONSENT_ACTION.SET_REGION:
      return {
        ...state,
        isEeaRegion: action.payload.isEeaRegion,
        shouldUseApk: action.payload.shouldUseApk ?? state.shouldUseApk,
        regionDetected: true
      }

    case CONSENT_ACTION.DISMISS_BANNER:
      return {
        ...state,
        hasShownBanner: true
      }

    default:
      return state
  }
}
